<template>
    <div class="dynamic-form-page q-mb-lg">
        <div v-for="(field, index) in structure.fields || []" :key="field.id" class="text-center q-mb-md">
            <q-separator v-if="index !== 0 && field.fieldType !== 'DISPLAY_TEXT'" class="q-my-lg" />
            <DynamicFormField 
                :ref="`field-${field.id}`"
                :field="field"
                :response="response"
                :approved-by-name="approvedByName"
                :read-only="readOnly"
                :show-opt-out="showOptOut"
                @field-value="(fieldId, key, value) => $emit('field-value', fieldId, key, value)"
            />
        </div>
    </div>
</template>

<script>
    import DynamicFormField from "./DynamicFormField.vue";

    export default {
        name: "DynamicFormPage",
        components: {DynamicFormField},
        props: {
            structure: {
                type: Object,
                required: true,
            },
            response: {
                type: Object,
                default: () => ({}),
            },
            approvedByName: {
                type: String,
                default: null,
            },
            readOnly: {
                type: Boolean,
                default: false,
            },
            showOptOut: {
                type: Boolean,
                default: true,
            },
        },
        emits: ['field-value'],
        methods: {
            /**
             * Validates all fields in this form page.
             * Fields are validated using their own validateField() method. This method doesn't check for required state.
             * @return Object with field IDs as keys and error messages as values for fields that failed validation.
             */
            validateAllFields() {
                const fieldErrors = {};
                
                if (this.structure.fields && this.structure.fields.length > 0) {
                    this.structure.fields.forEach((field) => {
                        const fieldRef = this.$refs[`field-${field.id}`];
                        if (fieldRef && fieldRef[0]) {
                            const isValid = fieldRef[0].validateField();
                            if (!isValid && fieldRef[0].fieldError) {
                                fieldErrors[field.id] = `${field.label} ${fieldRef[0].fieldError}`;
                            }
                        }
                    });
                }
                
                return fieldErrors;
            },
        },
    };
</script>
